import { Component, Input, OnInit } from '@angular/core';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-confirm-bloc',
  templateUrl: './confirm-bloc.component.html',
  styleUrls: ['./confirm-bloc.component.scss']
})
export class ConfirmBlocComponent implements OnInit{
  @Input() message1:string;
  @Input() message2:string;
  @Input() dialogRef;
  @Input() parcelInfo;
  @Input() tag;
  @Input() tagPageName;
  @Input() reasonCode;

  constructor(private atInternetService: AtInternetService) {}

  ngOnInit(){
    if(this.tag){
      if(this.reasonCode == "AF"){
        this.atInternetService.generatePage(this.tag, "reclamation_absence_facteur_confirmation", "reclamation_absence_facteur_confirmation");
      } else if( this.reasonCode =="CL"){
        this.atInternetService.generatePage(this.tag, "reclamation_contestation_livraison_confirmation", "reclamation_contestation_livraison_confirmation");
      } else {
        this.atInternetService.generatePage(this.tag, this.tagPageName, this.tagPageName);
      }
    }
  }

  closePopin(){
    this.dialogRef.close();   
  }
}
